import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import type * as fhirTypes from "fhir/r4";

interface UpdateAssessmentParams {
  referralReasonCode: string;
  referralUrgencyCode: string;
  referralProviderCode: string;
}

export const useUpdateReferOut = ({
  encounterId,
  carePlanId,
}: {
  encounterId: string;
  carePlanId: string;
}) => {
  const queryClient = useQueryClient();
  const { patientId } = useParams({ from: "/patient/$patientId" });

  return useApiMutation<fhirTypes.CarePlan, UpdateAssessmentParams>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Referrals.UPDATE,
      mutationFn: (params) => {
        return axiosInstance.put(
          `/amazon-clinic/care-plans/${carePlanId}/refer-out/`,
          params,
        );
      },
      onSuccess: () => {
        // Invalidate the recommendation API because the refer-out codes are
        // retrieved from the charting recommendation API, not directly from the
        // amazon-clinic API
        queryClient.invalidateQueries({
          queryKey:
            QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Recommendation.DEFAULT(
              { patientId, carePlanId, encounterId },
            ),
        });
      },
    },
  });
};
